(function (angular) {
  /**
   * Directive: integer
   */
  angular.module('acme.common.directive.integer', []).directive('integer', IntegerDirective);

  function IntegerDirective() {
    return {
      require: 'ngModel',
      restrict: 'A',
      link: function ($scope, $element, $attrs, modelCtrl) {
        $element.on('click', function (event) {
          event.target.select();
        });

        modelCtrl.$parsers.unshift(function (viewValue) {
          var transformedValue = parseInt(viewValue, 10);

          if (isNaN(transformedValue)) {
            transformedValue = 0;
            modelCtrl.$setViewValue(transformedValue);
            modelCtrl.$render();
          } else if (transformedValue.toString() !== viewValue.toString()) {
            modelCtrl.$setViewValue(transformedValue);
            modelCtrl.$render();
          }

          return transformedValue;
        });
      },
    };
  }
})(window.angular);
